// Defaults used before the household has configured anything.

import type { Household, Profile } from '../domain/types.ts';

export const DEFAULT_HOUSEHOLD: Household = {
  id: 'household',
  people: [
    { id: 'matt', name: 'Matt', color: '#2f6fb3', experienced: true },
    { id: 'nick', name: 'Nick', color: '#c2572b' },
  ],
  region: 'scotland',
  home: { type: 'flat', outdoorSpace: 'none', outsideMins: 3 },
  nightStart: '22:00',
  nightEnd: '06:30',
  toiletCue: 'Be quick',
};

export const DEFAULT_PROFILE: Profile = {
  id: 'arlo',
  name: 'Arlo',
  breed: 'Cocker Spaniel',
  cockerType: 'unknown',
  sex: 'male',
  colour: 'Red',
  food: {},
};
